import Notification from './Notification';

export default Notification;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Notification/index.js